import { Alert, Button } from '@salecycle/ui-component-library';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useMoveToStatus } from 'sections/onsite-campaigns/pages/CampaignEditor/hooks/useMoveToStatus';
import { useCampaignSettings } from '../../../../../state/CampaignSettings/hooks/useCampaignSettings';

export const RevertToDraftBanner = () => {
  const { status, setStatus } = useCampaignSettings();

  const moveToStatus = useMoveToStatus();
  const { t } = useTranslation('campaigns');

  const onCampaignStatusChanges = useCallback(
    status => {
      setStatus(status);
      moveToStatus(status);
    },
    [moveToStatus, setStatus],
  );

  return (
    <Alert
      heading={t('onsite.editor.workflow.workflowAlertCurrentStateHeading', { currentSate: status })}
      variation="info"
    >
      {t('onsite.editor.workflow.workflowAlertCurrentStateBody')}
      <Button
        style={{ marginTop: '15px' }}
        id="bannerWorkFlowID"
        onClick={() => onCampaignStatusChanges('Draft')}
        title="Revert to Draft"
        type="button"
        variation="secondary"
      />
    </Alert>
  );
};
